export default "__VITE_ASSET__a850d1ce__"